const defaultProtocol = {
  id: 'default',
  locked: true,
  hasUpdatedPriorsInformation: false,
  name: 'Default',
  createdDate: '2021-02-23T19:22:08.894Z',
  modifiedDate: '2021-02-23T19:22:08.894Z',
  availableTo: {},
  editableBy: {},
  protocolMatchingRules: [
    {
      attribute: 'ModalitiesInStudy',
      constraint: {
        contains: ['MR'],
      },
    },
  ],
  toolGroupIds: ['default'],
  displaySetSelectors: {
    MRDisplaySet: {
      seriesMatchingRules: [
        {
          // weight: 2,
          attribute: 'SeriesDescription',
          constraint: {
            contains: {
              value: 'Diag_',
            },
          },
          // required: true,  // ha required true csak a feltétel teljesülése esetén jelenik meg a viewportban, amihez az id tartozik (MRDisplaySet)
        },
        {
          // weight: 1,
          attribute: 'SeriesDescription',
          constraint: {
            contains: {
              value: 'Anat_',
            },
          },
          // required: true,
        },
        {
          attribute: 'SeriesDescription',
          constraint: {
            doesNotInclude: {
              value: ['Anat_', 'Diag_'],
            },
          },
        },
      ],
    },
  },
  stages: [
    {
      id: 'hYbmMy3b7pz7GLiaT',
      name: 'default',
      viewportStructure: {
        layoutType: 'grid',
        properties: {
          rows: 1,
          columns: 2,
        },
      },
      viewports: [
        {
          viewportOptions: {
            toolGroupId: 'default',
            // initialImageOptions: {
            //   index: 180,
            //   preset: 'middle', // 'first', 'last', 'middle'
            // },
          },
          displaySets: [
            {
              id: 'MRDisplaySet',
            },
          ],
        },
      ],
      createdDate: '2021-02-23T18:32:42.850Z',
    },
  ],
  numberOfPriorsReferenced: -1,
};




function getHangingProtocolModule() {
  return [
    {
      id: defaultProtocol.id,
      protocol: defaultProtocol,
    },
  ];
}

export default getHangingProtocolModule;
